import script from "./add.vue?vue&type=script&setup=true&lang=ts"
export * from "./add.vue?vue&type=script&setup=true&lang=ts"

import "./add.vue?vue&type=style&index=0&id=030aad66&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030aad66"]])

export default __exports__